(function () {
  'use strict';

  angular
    .module('activeInactiveCrewList')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('activeInactiveCrewList', {
          sticky: true,
          url: '/active-inactive-crew-list',
          views: {
              'activeInactiveCrewListView': {
                  templateUrl:'active-inactive-crew-list/views/active-inactive-crew-list.tpl.html',
                  controller: 'ActiveInactiveCrewListCtrl',
                  controllerAs: 'activeInactiveCrewList'
              }
          }
      });
  }
}());